module.exports = __webpack_public_path__ + "img/data-not-correct.d52178c9.svg";